// mutation-types.js
export const BOILERPLATE = 'BOILERPLATE'